module.exports = __webpack_public_path__ + "static/media/icon_arraw_right_gray.52e297bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_arraw_right_gray.png
// module id = 702
// module chunks = 0